import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {ChemicalData} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-edit-chemical',
    templateUrl: './edit-chemical.component.html',
    styleUrls: ['./edit-chemical.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditChemicalComponent {
  @Input() chemical: ChemicalData;
}
